import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Link, OAuthAuthenticationService, withRouter, logoutAction,
} from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './authInfo.scss';
import { getAuthState } from './redux/selectors/authInfoSelector';
import { RECEPTACLE_SEARCH_FORM_DATA } from '../../pages/ReceptacleSearchCriteria/constants';

const mapStateToProps = state => ({
  auth: getAuthState(state),
});

const Authenticated = (props) => {
  const {
    internalLogout,
    auth: { username },
  } = props;

  return (
    <div className="auth-info">
      <div className="icon-container">
        <span className="user-initials">{username.slice(0, 2)}</span>
      </div>
      <div className="auth-info-context-menu">
        <div className="choice" onClick={internalLogout}>
          <FontAwesomeIcon icon="sign-out-alt" />
          <div className="label"><FormattedMessage id="app.signOut" /></div>
        </div>
      </div>
    </div>
  );
};

Authenticated.propTypes = {
  internalLogout: PropTypes.func,
  auth: PropTypes.shape(),
};

const NoAuthenticated = (props) => {
  const { history } = props;
  return (
    <div className="auth-info">
      <div className="icon-container">
        <FontAwesomeIcon icon="user-circle" className="icon" />
      </div>
      <div className="auth-info-context-menu">
        <Link to={{ pathname: '/login', state: { from: history.location.pathname } }} className="choice">
          <FontAwesomeIcon icon="sign-in-alt" />
          <div className="label"><FormattedMessage id="app.signIn" /></div>
        </Link>
      </div>
    </div>
  );
};

NoAuthenticated.propTypes = {
  history: PropTypes.shape(),
};

export class AuthInfoComponent extends React.Component {
  render() {
    const { history, auth, logout } = this.props;
    const internalLogout = () => {
      localStorage.removeItem(RECEPTACLE_SEARCH_FORM_DATA);
      OAuthAuthenticationService.logout();
      logout();
    };

    return (
      auth.isAuthenticated() ? <Authenticated auth={auth} internalLogout={internalLogout} />
        : <NoAuthenticated history={history} />
    );
  }
}

AuthInfoComponent.propTypes = {
  history: PropTypes.objectOf(PropTypes.shape),
  logout: PropTypes.func,
  auth: PropTypes.objectOf(PropTypes.shape),
};

export default connect(mapStateToProps, { logout: logoutAction })(withRouter(AuthInfoComponent));
